
import { Vue, Component, Prop } from 'vue-property-decorator';
import TrackingNumber from '@/features/shipment-history/components/tableColumns/TrackingNumber.vue';
import { PickupPackageItemType, UnscheduledPickups } from '@/features/schedule-pickup/types';
import { useFormatTimestamp } from '@/features/common/helpers';
import { getCountryNameFromCode, getCutoffTime } from '@/features/shipment/helpers/createShipment';
import { ShipStatus, PackageType } from '@/features/shipment/types';
import { getCarrierLogoCode, getDisplayCarrierCode } from '@/features/common/helpers/carrier';
import PickupItemDetails from './PickupItemDetails.vue';

@Component({
  components: {
    TrackingNumber,
    PickupItemDetails,
  },
})
export default class PickupItem extends Vue {
  @Prop({ required: true }) pickup!: UnscheduledPickups;

  @Prop({ required: false, default: false }) isChecked!: boolean;

  private showExpand = false;

  private getDateString = useFormatTimestamp;

  private getCutoffTime = getCutoffTime;

  private packagesExpanded = false;

  private PackageType = PackageType;

  private getCountryNameFromCode = getCountryNameFromCode;

  get carrierLogoCode(): string {
    return getCarrierLogoCode(this.pickup.carrierCode, this.pickup.selectedService);
  }

  get displayCarrierCode(): string {
    return getDisplayCarrierCode(this.pickup.carrierCode, this.pickup.selectedService);
  }

  get fromCountryName(): string {
    if (!this.pickup.fromAddress.countryCode) return '';
    return this.getCountryNameFromCode(this.pickup.fromAddress.countryCode);
  }

  get isMoreThan5Packages(): boolean {
    return this.pickup.packages.length > 5;
  }

  get visiblePackages(): PickupPackageItemType[] {
    if (!this.isMoreThan5Packages) {
      return this.pickup.packages;
    }

    const exceptionPackages = this.pickup.packages
      .filter((p) => p.shipStatus === ShipStatus.Exception);
    const collapsedPackages: PickupPackageItemType[] = [...exceptionPackages];

    if (collapsedPackages.length < 5) {
      const qtyToAdd = 5 - collapsedPackages.length;
      const packagesToAdd = this.pickup.packages
        .filter((p) => p.shipStatus !== ShipStatus.Exception)
        .slice(0, qtyToAdd);

      collapsedPackages.push(...packagesToAdd);
    }

    return collapsedPackages;
  }

  get invisiblePackages(): PickupPackageItemType[] {
    return this.pickup.packages.filter((p) => !this.visiblePackages.includes(p));
  }

  get expandBtnText(): string {
    return this.packagesExpanded
      ? this.$t('buttons.less') as string
      : this.$t('buttons.showMore', { amount: this.invisiblePackages.length }) as string;
  }
}
